import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";
import { A } from "components/CallToAction";

export const IntroducingSavantPowerBanner = () => (
  <Section
    css={`
      flex-flow: column;
      justify-content: center;
      @media screen and (min-width: ${getSize("desktop1200")}) {
        padding-bottom: 80px;
        justify-content: end;
      }
      @media screen and (min-width: ${getSize("desktop1920")}) {
        padding-bottom: 200px;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query IntroducingSavantPowerBannerImageQuery {
          file(relativePath: { eq: "power-banner.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 25% 50%;
              @media screen and (min-width: ${getSize("tablet960")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <div
      css={`
        align-items: center;
        display: flex;
        flex-flow: column;
        height: 100%;
        justify-content: center;
        left: 0;
        padding: 31px 38px 35px 38px;
        position: absolute;
        right: 0;
        text-align: center;
        top: 0;
        width: 100%;

        @media screen and (min-width: ${getSize("mobile480")}) {
          padding: 38px 46px 40px 46px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          display: contents;
        }
      `}
    >
      <h2
        css={`
          color: ${({
            theme: {
              colors: { white },
            },
          }) => white};
          font-family: "Helvetica Neue", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 26px;
          margin: 0;
          text-transform: uppercase;
          width: 100%;
          @media screen and (min-width: ${getSize("tablet720")}) {
            font-size: 22px;
          }
          ${getFontFamily("regular")}
        `}
      >
        introducing
      </h2>
      <div
        css={`
          height: 26px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            height: 51px;
          }
        `}
      />
      <h1
        css={`
          height: auto;
          margin: 0;
          max-width: 464px;
          width: 100%;
        `}
      >
        <span className="hideAccessible">Savant Power</span>
        <img alt="Savant Power" src="/savant_power_logo.svg" />
      </h1>
      <div
        css={`
          height: 16px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            height: 32px;
          }
        `}
      />
      <p
        css={`
          color: ${({
            theme: {
              colors: { white },
            },
          }) => white};
          font-family: "Helvetica Neue", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 26px;
          margin: 0;
          max-width: 526px;
          text-align: center;
          @media screen and (min-width: ${getSize("tablet720")}) {
            font-size: 22px;
          }
          ${getFontFamily("regular")}
        `}
      >
        {
          "Designed for you in mind, our solutions will change the way you think about energy. Savant Power is rethinking the grid."
        }
      </p>
      <div
        css={`
          height: 26px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            height: 51px;
          }
        `}
      />
      <A
        css={`
          background-color: transparent;
          border-color: ${({
            theme: {
              colors: { white },
            },
          }) => white};
          color: ${({
            theme: {
              colors: { white },
            },
          }) => white};
          font-size: 10px;
          min-height: 31px;
          min-width: unset;
          padding: 8px 34px;
        `}
        href="https://cdn.savant.com/video/Energy_Utility.m4v"
      >
        Learn more
      </A>
    </div>
  </Section>
);
